module.exports = __webpack_public_path__ + "static/media/slider_3_es_sm.8d24bb86.svg";